var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcTrash = function SvgIcTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.462 4.308h1.23m0 0h9.847m-9.846 0v8.615a1.23 1.23 0 0 0 1.23 1.23h6.154a1.23 1.23 0 0 0 1.231-1.23V4.308H3.693Zm1.846 0V3.077a1.23 1.23 0 0 1 1.23-1.23h2.462a1.23 1.23 0 0 1 1.23 1.23v1.23"
  })));
};
export default SvgIcTrash;